import React from 'react';
import PropTypes from 'prop-types';

const ReportIcon = (props) => {
  return (
    <svg width={props.width} height={props.height} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 25">
      <title>Report Icon</title>
      <defs />
      <path
        d="M18.5,0h-17C0.7,0,0,0.7,0,1.5v15.9v0.1v3v3C0,24.3,0.7,25,1.5,25h17c0.8,0,1.5-0.7,1.5-1.5v-3v-3v-0.1V1.5
          C20,0.7,19.3,0,18.5,0z M1,1.5C1,1.2,1.2,1,1.5,1h17C18.8,1,19,1.2,19,1.5v16c0,0.3-0.2,0.5-0.5,0.5h-17C1.2,18,1,17.8,1,17.5V1.5z
          M19,23.5c0,0.3-0.2,0.5-0.5,0.5h-17C1.2,24,1,23.8,1,23.5v-1.6C1.2,22,1.3,22,1.5,22h17c0.2,0,0.3,0,0.5-0.1V23.5z M18.5,21h-17
          C1.2,21,1,20.8,1,20.5v-1.6C1.2,19,1.3,19,1.5,19h17c0.2,0,0.3,0,0.5-0.1v1.6C19,20.8,18.8,21,18.5,21z"
        fill="#595959"
      />
      <rect x="4" y="5" width="12" height="1" fill="#595959" />
      <rect x="4" y="9" width="12" height="1" fill="#595959" />
      <rect x="4" y="13" width="8" height="1" fill="#595959" />
    </svg>
  );
};

ReportIcon.propTypes={
  width: PropTypes.number,
  height: PropTypes.number,
}

ReportIcon.defaultProps={
  width: 20,
  height: 25,
}

export default ReportIcon;
